import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.policies[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.policies[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectSearchPoliciesResults = (state) => state.policies?.searchPoliciesResults;
export const selectSearchPoliciesLoading = isLoadingSelector('searchPoliciesStatus');

export const selectPolicies = (state) => state.policies?.policies;
export const selectPoliciesLoading = isLoadingSelector('policiesStatus');

export const selectTotalPolicies = (state) => state.policies?.totalPolicies;

export const selectExportPoliciesLoading = isLoadingSelector('exportPoliciesStatus');
export const selectExportPoliciesFailed = isFailedSelector('exportPoliciesStatus');

export const selectLastVisitedPolicyId = (state) => state.policies?.lastVisitedPolicyId;
